import { render, staticRenderFns } from "./ClassAdviserDialog.vue?vue&type=template&id=5e42cc2e&scoped=true&"
import script from "./ClassAdviserDialog.vue?vue&type=script&lang=js&"
export * from "./ClassAdviserDialog.vue?vue&type=script&lang=js&"
import style0 from "./ClassAdviserDialog.vue?vue&type=style&index=0&id=5e42cc2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e42cc2e",
  null
  
)

export default component.exports